package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.runtime.Composable
import androidx.compose.ui.window.DialogProperties

actual fun fullscreenDialogProperties() = DialogProperties(
    usePlatformDefaultWidth = false,
    dismissOnBackPress = true,
    dismissOnClickOutside = false
)

@Composable
actual fun DialogTransparentSystemBars() {}
